import configListeners from './configListeners';
import listeners from './listeners';
import workload from './workload';
import multiview from './multiview';
import exportListeners from './export';
import app from '$$app';

class GanttAdapter {
  constructor() {
    this.storeSubscriptions = [];
    this.appSubscriptions = [];
  }

  init(instance) {
    const configSubs = configListeners(instance);

    this.storeSubscriptions.push(configSubs.storeSubscription);
    this.storeSubscriptions.push(listeners(instance));

    const workloadSubs = workload(instance);
    const multiviewSubs = multiview(instance);

    this.appSubscriptions = [
      ...configSubs.appSubscriptions,
      ...workloadSubs.appSubscriptions,
      ...multiviewSubs.appSubscriptions,
    ];
  }

  initForExport(instance) {
    const configSubs = exportListeners(instance);

    this.storeSubscriptions.push(configSubs.storeSubscription);
    this.appSubscriptions.push(...configSubs.appSubscriptions);
  }

  initForArchived(instance) {
    const configSubs = configListeners(instance);

    this.storeSubscriptions.push(configSubs.storeSubscription);
    this.appSubscriptions.push(...configSubs.appSubscriptions);
  }

  destruct() {
    while (this.storeSubscriptions.length) {
      this.storeSubscriptions.pop()();
    }
    while (this.appSubscriptions.length) {
      app.off(this.appSubscriptions.pop());
    }
  }
}

export default new GanttAdapter();
